module.exports = __webpack_public_path__ + "static/img/4030_phase_function_Paper_PointsHejduk_Prediction.8f43a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4030_phase_function_Paper_PointsHejduk_Prediction.png
// module id = j6Ma
// module chunks = 0